/**
 * @fileoverview Componente del footer del sitio
 * @author Jonatan Bianchi - Bianchi Desarrollo Web
 * @website https://jonatan.bianchi.com.ar
 * @email jonatan@bianchi.com.ar
 * @company Bianchi Desarrollo Web
 * @website https://www.bianchi.com.ar
 * @email info@bianchi.com.ar
 * @copyright 2025 Bianchi Desarrollo Web
 */

import { Component, inject, PLATFORM_ID } from '@angular/core';
import { isPlatformBrowser } from '@angular/common';
import { Router, RouterLink } from '@angular/router';

/**
 * Componente del footer
 * Muestra enlaces, información legal y copyright
 */
@Component({
  selector: 'app-footer',
  standalone: true,
  imports: [RouterLink],
  templateUrl: './footer.component.html',
  styleUrl: './footer.component.css'
})
export class FooterComponent {
  protected readonly currentYear = new Date().getFullYear();
  private router = inject(Router);
  private platformId = inject(PLATFORM_ID);

  /**
   * Navega a un fragmento en la página
   * Si estamos en la página principal, hace scroll directamente
   * Si estamos en otra página, navega primero a "/" y luego al fragmento
   */
  navigateToFragment(fragment: string, event?: Event): void {
    if (event) {
      event.preventDefault();
    }

    if (!isPlatformBrowser(this.platformId)) return;

    const currentUrl = this.router.url.split('#')[0];
    
    if (currentUrl === '/') {
      // Ya estamos en la página principal, hacer scroll al fragmento
      this.scrollToFragment(fragment);
    } else {
      // Estamos en otra página, navegar primero a "/" y luego al fragmento
      this.router.navigate(['/'], { fragment: fragment }).then(() => {
        setTimeout(() => this.scrollToFragment(fragment), 100);
      });
    }
  }

  /**
   * Hace scroll suave al elemento con el ID del fragmento
   */
  private scrollToFragment(fragment: string): void {
    if (!isPlatformBrowser(this.platformId)) return;

    const element = document.getElementById(fragment);
    if (element) {
      const offset = 80; // Altura del navbar fixed
      const elementPosition = element.getBoundingClientRect().top;
      const offsetPosition = elementPosition + window.pageYOffset - offset;

      window.scrollTo({
        top: offsetPosition,
        behavior: 'smooth'
      });
    }
  }
}

